var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.88911 3.04058C3.65479 2.80627 3.27489 2.80627 3.04058 3.04058C2.80627 3.27489 2.80627 3.65479 3.04058 3.88911L3.88911 3.04058ZM10.1116 10.9602C10.346 11.1945 10.7259 11.1945 10.9602 10.9602C11.1945 10.7259 11.1945 10.346 10.9602 10.1116L10.1116 10.9602ZM3.04058 3.88911L10.1116 10.9602L10.9602 10.1116L3.88911 3.04058L3.04058 3.88911Z",
    fill: "#001636",
    fillOpacity: 0.92
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.21245 15.94C2.97814 16.1743 2.97814 16.5542 3.21245 16.7885C3.44677 17.0228 3.82667 17.0228 4.06098 16.7885L3.21245 15.94ZM16.7889 4.0606C17.0232 3.82629 17.0232 3.44639 16.7889 3.21207C16.5546 2.97776 16.1747 2.97776 15.9404 3.21207L16.7889 4.0606ZM4.06098 16.7885L16.7889 4.0606L15.9404 3.21207L3.21245 15.94L4.06098 16.7885Z",
    fill: "#001636",
    fillOpacity: 0.92
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.88423 9.04058C9.64991 8.80627 9.27001 8.80627 9.0357 9.04058C8.80138 9.27489 8.80138 9.65479 9.0357 9.88911L9.88423 9.04058ZM16.1068 16.9602C16.3411 17.1945 16.721 17.1945 16.9553 16.9602C17.1896 16.7259 17.1896 16.346 16.9553 16.1116L16.1068 16.9602ZM9.0357 9.88911L16.1068 16.9602L16.9553 16.1116L9.88423 9.04058L9.0357 9.88911Z",
    fill: "#001636",
    fillOpacity: 0.92
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.fffc73af52723067fbc59b34a316940b.svg";
export { ForwardRef as ReactComponent };